module.exports = __webpack_public_path__ + "PnxCspIcons.667d9abf742ade45c6d5.eot";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/fonts/PnxCspIcons/fonts/PnxCspIcons.eot?gea4vk
// module id = ../../../../../client/assets/fonts/PnxCspIcons/fonts/PnxCspIcons.eot?gea4vk
// module chunks = styles